// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconEngland_icon__2xz94"};